<template>
  <div class="layout-img">
    <slot name="title"></slot>
    <b-row>
      <template v-for="(item, index) in dataList">
        <b-col
          :key="index"
          :cols="cols"
          :md="md"
          style="display: flex; justify-content: center"
        >
          <a v-if="item.url" :href="item.url">
            <div class="img-wrap img-hovor">
              <img width="100%" height="100%" :src="item.titleImg" />
            </div>
            <div style="width: 90%; margin: 0rem 0rem 5rem 1rem">
              <p class="title">
                {{ item.title }}
              </p>
              <ul>
                <li v-for="(value, index) in item.rank" :key="index">
                  {{ value }}
                </li>
              </ul>
            </div>
          </a>
          <router-link v-else :to="`/forum/about/character?id=${item.id}`">
            <div class="img-wrap img-hovor">
              <img width="100%" height="100%" :src="item.titleImg" />
            </div>
            <div class="list">
              <p class="title">
                {{ item.title }}
              </p>
              <div class="list-text">
                <ul>
                  <li v-for="(value, index) in item.rank" :key="index">
                    {{ value }}
                  </li>
                </ul>
              </div>
            </div>
          </router-link>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    institution: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "activity",
    },
    position: {
      type: String,
      default: "center",
    },
    height: {
      type: String,
      default: "14.2rem",
    },
    md: Number,
    cols: Number,
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  watch: {
    dataList(val) {
      console.log(val);
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.layout-img ::v-deep {
  .img-wrap {
    margin: 1rem auto;
    border-radius: 10px;
    img:hover {
      transform: scale(1.05, 1.05);
      transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1),
        opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }
}

a {
  text-decoration: none;
  cursor: pointer;
}

li {
  list-style-type: initial;
  font-size: 1rem;
  color: #666666;
}

@media screen and (min-width: 900px) {
  .img-wrap {
    height: 16rem;
    width: 16rem;
  }
  .list-text {
    padding-left: 1.2rem;
    width: 15rem;
  }
  .title {
    text-align: center;
    color: #4a4a4a;
    font-size: 1.25rem;
  }
}

@media (max-width: 768px) {
  .img-wrap {
    width: 10rem;
    height: 10rem;
  }
  li {
    transform: scale(0.88);
  }
  .list-text {
    //  transform: translateX(0.6rem);
    margin-left: 1.5rem;
    min-height: 12.3rem;
  }
  .title {
    text-align: center;
    color: #4a4a4a;
    font-size: 14px;
  }
}
</style>